export default __webpack_public_path__ + "static/media/undo-icon.19672ecf.svg";